var _rect, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoonIcon = function SvgMoonIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.799805,
    y: 0.399994,
    width: 21.2,
    height: 21.2,
    rx: 10.6,
    fill: "#ECF2F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_120_935)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.882 6.17667C10.882 6.17675 10.882 6.17683 10.8819 6.17691L10.8819 6.17714L10.8803 6.18219C10.8787 6.18713 10.8763 6.19521 10.873 6.20629C10.8664 6.22844 10.8566 6.26252 10.8445 6.30738C10.8204 6.39717 10.7875 6.52978 10.7538 6.69606C10.6863 7.02949 10.6168 7.49354 10.608 8.01627C10.5903 9.07052 10.819 10.3025 11.7329 11.2165C12.6469 12.1305 13.8789 12.3591 14.9332 12.3414C15.4559 12.3326 15.92 12.2632 16.2534 12.1956C16.4197 12.162 16.5523 12.129 16.6421 12.1049C16.6869 12.0929 16.721 12.083 16.7431 12.0765C16.7542 12.0732 16.7623 12.0707 16.7673 12.0692L16.7723 12.0676L16.7725 12.0675L16.7728 12.0674C16.9204 12.0198 17.0824 12.059 17.1918 12.169C17.3013 12.2791 17.3398 12.4413 17.2913 12.5888C16.5712 14.7798 14.5089 16.3625 12.0758 16.3625C9.04438 16.3625 6.58691 13.9051 6.58691 10.8736C6.58691 8.44058 8.16968 6.37828 10.3606 5.65815C10.5081 5.60967 10.6704 5.64811 10.7804 5.75763C10.8903 5.86702 10.9296 6.02882 10.8821 6.17642C10.8821 6.17645 10.8821 6.17648 10.8821 6.17651C10.8821 6.17652 10.8821 6.17653 10.8821 6.17654C10.882 6.17658 10.882 6.17663 10.882 6.17667M16.205 13.0443C15.8609 13.1046 15.4274 13.1582 14.947 13.1663C13.7854 13.1858 12.2883 12.9386 11.1496 11.7999C10.0108 10.6611 9.7636 9.16405 9.78314 8.0024C9.79122 7.52203 9.84486 7.08857 9.90516 6.74446C8.42234 7.52558 7.41191 9.08201 7.41191 10.8736C7.41191 13.4494 9.50001 15.5375 12.0758 15.5375C13.8674 15.5375 15.4239 14.5271 16.205 13.0443Z",
    fill: "#66717C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_120_935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.2,
    height: 13.2,
    fill: "white",
    transform: "translate(4.7998 4.39999)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoonIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moon-icon.101739e2.svg";
export { ForwardRef as ReactComponent };